import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import DateTime from "../../../../components/Formatters/DateTime";
import TextSpinner from "../../../../components/UI/Spinner/TextSpinner";
import useDetalhamento from "../hooks/useDetalhamento";
import FormDemonstrativos from "../FormDemonstrativos";
import useMontarLogica from "../hooks/useMontarLogica";
import constants from "../../../Constants";

const columns = [
  {
    name: "Nº Série ECF",
    selector: (row) => row.nuSerieEcf,
  },
  {
    name: "Nº Redução Z",
    selector: (row) => row.nuReducaoZ,
    minWidth: "14%",
  },
  {
    name: "Data Redução Z",
    selector: (row) => row.dtReducaoZ,
    minWidth: "15%",
    cell: (row) => <DateTime value={row.dtEmissao} stringFormat="dd/MM/yyyy" />,
  },
  {
    name: "Data de Vencimento",
    selector: (row) => row.dtVencimento,
    minWidth: "15%",
    cell: (row) => <DateTime value={row.dtVencimento} stringFormat="dd/MM/yyyy" />,
  },
  {
    name: "Base de Cálculo",
    selector: (row) => row.vlBaseCalculo,
  },
  {
    name: "% Alíquota Irregular",
    selector: (row) => row.aliquotaIrregular,
  },
  {
    name: "% Alíquota Correta",
    selector: (row) => row.aliquotaCorreta,
  },
  {
    name: "ICMS",
    selector: (row) => row.vlIcms,
  },
  {
    name: "Multa",
    selector: (row) => row.vlMultaOcorrenciaAtual,
  },
];

const conditionalRowStyles = [
  {
    when: (row) => row.dsItem === "Total",
    style: { backgroundColor: "#d3d3d3", cursor: "not-allowed" },
  },
];

const ListagemS = ({ history, sqItemOcorrencia, sqAcaoFiscal }) => {
  const [reload, setReload] = useState(false); // Estado para forçar a atualização
  const { dataWithTotal, totalRows, isLoading } = useDetalhamento({
    sqAcaoFiscal,
    sqItemOcorrencia,
    reload,
  });

  const [dados, setDados] = useState({});

  const { montarLogica, mostrarLista, setMostrarLista } = useMontarLogica();

  useEffect(() => {
    if (mostrarLista) {
      montarLogica(1);
    }
  }, [montarLogica, mostrarLista, reload]);

  const voltarListagem = () => {
    setMostrarLista(true);
    setReload((prev) => prev + 1);
  };

  return mostrarLista ? (
    <DataTable
      noHeader
      keyField="sqItemOcorrencia"
      columns={columns}
      data={dataWithTotal}
      progressPending={isLoading}
      noDataComponent="Nenhum registro para exibir"
      progressComponent={<TextSpinner />}
      paginationTotalRows={totalRows}
      pointerOnHover
      pagination
      paginationComponentOptions={constants.paginationComponentOptions}
      onRowClicked={(row) => {
        if (row.nuSerieEcf !== "Total") {
          setDados(row);
          montarLogica(4);
        }
      }}
      conditionalRowStyles={conditionalRowStyles}
      paginationPerPage={10}
      selectableRowDisabled={(row) => row.nuSerieEcf === "Total"}
      selectableRowsVisibleOnly={(row) => !(row.nuSerieEcf === "Total")}
    />
  ) : (
    <FormDemonstrativos
      tipoDetalhamento={dados.tipoDetalhamento}
      sqItemOcorrencia={dados.sqItemOcorrencia}
      sqAcaoFiscal={dados.sqAcaoFiscal}
      dadosOcorrencia={dados}
      history={history}
      voltarListagem={() => voltarListagem()}
    />
  );
};

export default ListagemS;
